export function validMobile(rule, value, callback) {
  let reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
  if (!value) {
    callback(new Error("请输入手机号"));
  } else {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error("请输入正确格式的手机号"));
    }
  }
}
